import DgMenu from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgMenu.install = function (Vue) {
  Vue.component(DgMenu.name, DgMenu)
}
export default DgMenu

export { DgMenu }